import { render, staticRenderFns } from "./chatInput.vue?vue&type=template&id=7667fb0a&scoped=true"
import script from "./chatInput.vue?vue&type=script&lang=js"
export * from "./chatInput.vue?vue&type=script&lang=js"
import style0 from "./chatInput.vue?vue&type=style&index=0&id=7667fb0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7667fb0a",
  null
  
)

export default component.exports